import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=22f2b805&"
import script from "./ClassList.vue?vue&type=script&lang=js&"
export * from "./ClassList.vue?vue&type=script&lang=js&"
import style0 from "./ClassList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f2b805')) {
      api.createRecord('22f2b805', component.options)
    } else {
      api.reload('22f2b805', component.options)
    }
    module.hot.accept("./ClassList.vue?vue&type=template&id=22f2b805&", function () {
      api.rerender('22f2b805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/ClassList.vue"
export default component.exports